import { render, staticRenderFns } from "./IngredientShow.vue?vue&type=template&id=464cc844&"
import script from "./IngredientShow.vue?vue&type=script&lang=js&"
export * from "./IngredientShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports